import { lazy } from "react";

export const CitizenCharter = lazy(
  () => import("../../Features/CitizenCharter")
);
